<template>
  <div class="p-grid container-send-main">
    <div class="p-12">
      <div class="p-fluid p-formgrid p-grid p-mt-6">
        <div class="p-field p-col-12 p-md-7">
          <label for="nombre">{{ $t("messages.nameAndLastName") }}</label>
          <InputText id="nombre" type="text" v-model.trim="nombre" required="true" autofocus
            :class="{ 'p-invalid': submitted && !nombre }" />
        </div>
        <div class="p-field p-col-12 p-md-7">
          <label for="email">{{ $t("messgaes.email") }}</label>
          <InputText id="email" type="email" v-model.trim="email" required="true" autofocus
            :class="{ 'p-invalid': submitted && !email }" />
        </div>
        <div class="p-field p-col-12 p-md-7">
          <label for="telefono">{{ $t("messages.contactPhone") }}</label>
          <InputText id="telefono" type="text" v-model.trim="telefono" required="true" autofocus
            :class="{ 'p-invalid': submitted && !telefono }" />
        </div>
        <div class="p-field p-col-12">
          <label for="contenido">{{ $t("messages.yourMessage") }}</label>
          <Textarea id="contenido" rows="5" v-model.trim="comentario" required="true" autofocus
            :class="{ 'p-invalid': submitted && !comentario }" />
        </div>
        <div class="p-field p-col-12" style="display: flex;flex-direction: column;width: 100%;">
          <BotonPolitica />
          <div class="field-checkbox p-mt-3">            
            <label for="contenido"  class="p-mr-2" >{{ $t("messages.acceptDataPolicy") }}</label>
            <Checkbox id="aceptaPolitica" v-model="aceptaPolitica" :binary="true" required="true" autofocus
              :class="{ 'p-invalid': submitted && !aceptaPolitica }" />
          </div>
        </div>
        <div class="p-field p-col-12 p-md-4 p-mt-5">
          <label for="verificacion">{{ $t("messages.howMuchIs") }} {{ numero1 }}+{{ numero2 }}</label>
          <InputText id="verificacion" type="number" v-model.trim="resultado" />
        </div>
        <div class="p-field p-col-12 p-text-center">
          <Button label="Enviar" name="enviar" style="width:200px;margin:0px auto;justify-content:center"
            @click="enviarCorreo" :disabled="enviando">{{ $t("messages.send") }}<i class="pi pi-spin pi-spinner p-ml-2"
              style="font-size: 1rem" v-if="enviando"></i></Button>              
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuariosService from "../service/usuarios.service";
import BotonPolitica from "./boton_politicas.vue";
export default {
  components: {
    BotonPolitica
  },
  props: {
    correoespecialista: {
      type: String,
      required: true,      
    },
    nombreespecialista: {
      type: String,
      required: true,      
    },
    onSave: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      usuariosService: null,
      nombre: "",
      email: "",
      telefono: "",
      comentario: "",
      verificacion: 0,
      resultado: 0,
      numero1: 0,
      numero2: 0,
      enviando: false,
      aceptaPolitica: false,
      submitted: false,
      invalidEmail: false,
    };
  },
  created() {
    this.usuariosService = new UsuariosService();
  },
  mounted() {
    this.numero1 = this.getRandomInt(10, 20);
    this.numero2 = this.getRandomInt(10, 20);
    this.submitted = false;
  },
  methods: {
    enviarCorreo() {
      this.submitted = true;
      this.validateEmail();
      if (!this.aceptaPolitica || !this.nombre || !this.email || !this.telefono || !this.comentario) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.$t("messages.allFieldsAreRequired"),
          life: 3000,
        });
        return false;
      }
      if (this.resultado != this.numero1 + this.numero2) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.$t("messages.verificationFailed"),
          life: 3000,
        });
        this.numero1 = this.getRandomInt(10, 20);
        this.numero2 = this.getRandomInt(10, 20);
        return false;
      }      
      this.enviando = true;
      this.usuariosService
        .enviarCorreoAEspecialista({
          nombre: this.nombre,
          email: this.email,
          telefono: this.telefono,
          comentario: this.comentario,          
          correo_especialista: this.correoespecialista,
          nombre_especialista: this.nombreespecialista,
        })
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Contactame",
            detail: this.$t("messages.messageSent"),
            life: 3000,
          });
          this.nombre = "";
          this.email = "";
          this.telefono = "";
          this.comentario = "";
          this.numero1 = this.getRandomInt(10, 20);
          this.numero2 = this.getRandomInt(10, 20);
          this.resultado = 0;
          this.enviando = false;
          if (this.onSave) {
            this.onSave();
          }
        })
        .catch((err) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: this.$t("messages.errorTryAgain"),
            life: 3000,
          });
          this.enviando = false;
          console.log(err);
        });
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    validateEmail() {
      const re = /\S+@\S+\.\S+/;
      console.log(re.test(this.email));
      this.invalidEmail = !re.test(this.email);
    },
  },
};
</script>

<style scoped>
h1 {
  margin: 10px 0px !important;
}

.containerFull {
  padding: 20px 300px;
}

p {
  font-size: 18px;
  margin: 0px;
}

.container-send-main {
  max-width: 50vw;
}

@media screen and (max-width: 1740px) {
  .containerFull {
    padding: 20px 40px;
  }
}

@media screen and (max-width: 800px) {
  .containerFull {
    padding: 20px 10px;
  }

  img {
    height: 290px;
    margin: 0px auto;
  }

  .container-send-main {
    max-width: 100vw;
  }
}
</style>
